import React, { useState, useEffect } from 'react';
import SearchBar from '../components/SearchBar/SearchBar';
import FollowUpReviewTable from '../components/FollowUpTables/FollowUpReviewTable';
import FollowUpSendingTable from '../components/FollowUpTables/FollowUpSendingTable';
import FollowUpFilterButton from '../components/FilterButton/FollowUpFilterButton';
import { CSSTransition } from 'react-transition-group';
import './FollowUpPage.scss';
import { API } from '../data/API/API';
import FollowUpFilterForm from '../components/FollowUpFilterForm/FollowUpFilterForm';
import { ToggleButton, ButtonGroup, Modal, Button } from 'react-bootstrap';
import FollowUpPhoneReviewTable from '../components/FollowUpTables/FollowUpPhoneReviewTable';
interface PhoneReview {
  id: number;
  supplierName: string;
  supplierOrgNr: string;
  customerName: string;
  customerOrgNr: string;
  contactPerson?: string;
  period: string;
  endPeriod: string;
  status: number;
  isHandled: boolean;
  created: string;
  updated: string;
}

  interface Review {
    id: number;
    supplierName: string;
    orgNumber: string;
    createdDate: string;
    createdBy: string;
    period: string;
  }

  interface Sending {
    id: number;
    customerName: string;
    orgNumber: string;
    createdDate: string;
    updatedDate: string;
    status: number;
    isHandled: boolean;
    supplierName: string;
    isSelected?: boolean; // New field to track selection state
  }

const FollowUpPage = () => {
 const [activeTable, setActiveTable] = useState<'review' | 'sending' | 'phone'>('review');
 const [phoneReviewData, setPhoneReviewData] = useState<PhoneReview[]>([]);
  const [searchText, setSearchText] = useState('');
  const [loading, setLoading] = useState(true);
  const [reviewData, setReviewData] = useState<Review[]>([]);
  const [sendingData, setSendingData] = useState<Sending[]>([]);
  const [selectedSendingIds, setSelectedSendingIds] = useState<number[]>([]); // Track selected sending IDs
  const [showConfirmModal, setShowConfirmModal] = useState(false); // Modal state
  const [showFilters, setShowFilters] = useState(false);
  

  // Separate filter states for each table
  const [reviewFilters, setReviewFilters] = useState({
    orgNumber: '',
    name: '',
  });

  const [sendingFilters, setSendingFilters] = useState({
    orgNumber: '',
    name: '',
    status: '',
    isHandled: 'unhandled', // Default to 'Ej slutförd'
  });

  // Filtered data based on currently active filters
  const filteredReviewData = reviewData.filter((item) => {
    const matchesOrg = !reviewFilters.orgNumber || item.orgNumber === reviewFilters.orgNumber;
    const matchesName = !reviewFilters.name || item.supplierName.includes(reviewFilters.name);
    return matchesOrg && matchesName;
  });

  const filteredSendingData = sendingData.filter((item) => {
    const matchesSearch =
      item.customerName?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.orgNumber?.includes(searchText) ||
      item.id.toString().includes(searchText) ||
      String(item.status).includes(searchText) ||
      item.supplierName.toLowerCase().includes(searchText.toLowerCase()); // Include supplier name in search

    const matchesOrgNumber = !sendingFilters.orgNumber || item.orgNumber === sendingFilters.orgNumber;
    const matchesName = !sendingFilters.name || item.customerName.includes(sendingFilters.name);
    const matchesStatus = !sendingFilters.status || item.status.toString() === sendingFilters.status;

    // Filter for isHandled based on filter value
    const matchesIsHandled =
      sendingFilters.isHandled === 'all' ||
      (sendingFilters.isHandled === 'handled' && item.isHandled) ||
      (sendingFilters.isHandled === 'unhandled' && !item.isHandled);

    return matchesSearch && matchesOrgNumber && matchesName && matchesStatus && matchesIsHandled;
  });

  // Generate distinct name and orgNumber options based on the filtered data
  const getFilteredOptions = (data: { name?: string; orgNumber: string }[], currentFilters: { orgNumber: string; name: string }, type: 'name' | 'orgNumber') => {
    const uniqueValues = new Set();

    return data.reduce((acc, item) => {
      const matchesCurrentFilters =
        (!currentFilters.orgNumber || item.orgNumber === currentFilters.orgNumber) &&
        (!currentFilters.name || item.name?.toLowerCase().includes(currentFilters.name.toLowerCase()));

      if (matchesCurrentFilters) {
        const value = type === 'name' ? item.name : item.orgNumber;
        if (value && !uniqueValues.has(value)) {
          uniqueValues.add(value);
          acc.push({ value, label: value });
        }
      }
      return acc;
    }, [] as { value: string; label: string }[]);
  };

  // Name and Org number options based on filtered data
  const nameOptions = activeTable === 'review'
    ? getFilteredOptions(reviewData.map(({ supplierName, orgNumber }) => ({ name: supplierName, orgNumber })), reviewFilters, 'name')
    : getFilteredOptions(sendingData.map(({ customerName, orgNumber }) => ({ name: customerName, orgNumber })), sendingFilters, 'name');

  const orgNumberOptions = activeTable === 'review'
    ? getFilteredOptions(reviewData.map(({ supplierName, orgNumber }) => ({ name: supplierName, orgNumber })), reviewFilters, 'orgNumber')
    : getFilteredOptions(sendingData.map(({ customerName, orgNumber }) => ({ name: customerName, orgNumber })), sendingFilters, 'orgNumber');

const filteredPhoneReviewData = phoneReviewData.filter((item) => {
  const matchesSearch =
    item.customerName?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.customerOrgNr?.includes(searchText) ||
    item.supplierName?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.supplierOrgNr?.includes(searchText) ||
    item.id.toString().includes(searchText);

  return matchesSearch;
});
  // Function to fetch review and sending data
const fetchData = async () => {
  setLoading(true);
  try {
    const reviewResponse = await API.Reviews.GetAllReviews();
    const sendingResponse = await API.Sendings.GetAllSendings();
    const phoneResponse = await API.PhoneReviews.getAll();

    setReviewData(reviewResponse);
    setSendingData(sendingResponse);
    setPhoneReviewData(phoneResponse);

    console.log('vi triggade en refetch pga av status ändringar', {
      reviewResponse,
      sendingResponse,
      phoneResponse
    });
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoading(false);
  }
};
  // Fetch review and sending data on mount
  useEffect(() => {
    fetchData();
  }, []);

  const handleFilterClick = () => {
    setShowFilters(!showFilters); // Toggle filter visibility
  };

  // Handle selection of sendings
  const handleSelectSending = (sendingId: number, isSelected: boolean) => {
    setSelectedSendingIds((prevSelectedIds) =>
      isSelected ? [...prevSelectedIds, sendingId] : prevSelectedIds.filter((id) => id !== sendingId)
    );
  };

  // Handle bulk mark as handled
  const handleMarkAsHandled = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmMarkAsHandled = async () => {
    try {
      await API.Sendings.UpdateSendingHandledStatusBulk(selectedSendingIds, true);
      fetchData(); // Refetch data to update the table
    } catch (error) {
      console.error('Error marking sendings as handled:', error);
    } finally {
      setShowConfirmModal(false);
      setSelectedSendingIds([]); // Clear selected sendings after action
    }
  };

  return (
    <div className="follow-up-page-container">
      <h1 className="follow-up-header">Uppföljning</h1>

      <div className="search-controls">
        <SearchBar placeholder="Sök..." value={searchText} onChange={(newValue) => setSearchText(newValue)} />
        <ButtonGroup className="followup-toggle-group">
          <ToggleButton
            type="radio"
            variant="outline-primary"
            checked={activeTable === 'review'}
            value="review"
            onClick={() => setActiveTable('review')}
            className={`followup-btn ${activeTable === 'review' ? 'active-btn' : 'inactive-btn'}`}
          >
            Granskningar
          </ToggleButton>
          <ToggleButton
            type="radio"
            variant="outline-primary"
            checked={activeTable === 'sending'}
            value="sending"
            onClick={() => setActiveTable('sending')}
            className={`followup-btn ${activeTable === 'sending' ? 'active-btn' : 'inactive-btn'}`}
          >
            Utskick
          </ToggleButton>
        
    <ToggleButton
  type="radio"
  variant="outline-primary"
  checked={activeTable === 'phone'}
  value="phone"
  onClick={() => setActiveTable('phone')}
  className={`followup-btn ${activeTable === 'phone' ? 'active-btn' : 'inactive-btn'}`}
>
  Telefongranskningar
</ToggleButton>
        </ButtonGroup>
        <FollowUpFilterButton onFilterClick={handleFilterClick} />
      </div>

      <CSSTransition in={showFilters} timeout={300} classNames="filter-collapse" unmountOnExit>
        <div className="filter-container">
          <FollowUpFilterForm
            orgNumber={
              activeTable === 'review' ? reviewFilters.orgNumber : sendingFilters.orgNumber
            }
            setOrgNumber={(newOrgNumber) =>
              activeTable === 'review'
                ? setReviewFilters((prev) => ({ ...prev, orgNumber: newOrgNumber as string }))
                : setSendingFilters((prev) => ({ ...prev, orgNumber: newOrgNumber as string }))
            }
            name={activeTable === 'review' ? reviewFilters.name : sendingFilters.name}
            setName={(newName) =>
              activeTable === 'review'
                ? setReviewFilters((prev) => ({ ...prev, name: newName as string }))
                : setSendingFilters((prev) => ({ ...prev, name: newName as string }))
            }
            status={activeTable === 'sending' ? sendingFilters.status : ''}
            setStatus={(newStatus) =>
              setSendingFilters((prev) => ({ ...prev, status: newStatus as string }))
            }
            isHandled={sendingFilters.isHandled}
            setIsHandled={(newIsHandled) =>
              setSendingFilters((prev) => ({ ...prev, isHandled: newIsHandled as string }))
            }
            isSendingTable={activeTable === 'sending'}
            nameOptions={nameOptions}
            orgNumberOptions={orgNumberOptions}
          />
        </div>
      </CSSTransition>

      {/* {activeTable === 'review' ? (
        <FollowUpReviewTable
          searchText={searchText}
          orgNumber={reviewFilters.orgNumber}
          name={reviewFilters.name}
          isLoading={loading}
          reviewData={filteredReviewData}
          refetchData={fetchData}
        />
      ) : (
        <>
          <FollowUpSendingTable
            searchText={searchText}
            orgNumber={sendingFilters.orgNumber}
            name={sendingFilters.name}
            status={sendingFilters.status}
            isHandled={sendingFilters.isHandled}
            isLoading={loading}
            sendingData={filteredSendingData}
            refetchData={fetchData} // Pass refetch function to child
            onSelectSending={handleSelectSending} // Pass selection handler
            selectedSendingIds={selectedSendingIds} // Pass selected sendings
          />
          {
            selectedSendingIds.length !== 0 &&
            <div className="bulk-actions">
              <button
                className="btn handled-button"
                disabled={selectedSendingIds.length === 0}
                onClick={handleMarkAsHandled}
                style={{ marginTop: '12px' }}
                >
                Markera som slutförd
              </button>
            </div>
          }

        
          <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Bekräfta Åtgärd</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Är du säker på att du vill markera de valda sändningarna som slutförda?
            </Modal.Body>
            <Modal.Footer>
              <button className="btn button-cancel" onClick={() => setShowConfirmModal(false)}>
                Avbryt
              </button>
              <button className="btn" onClick={handleConfirmMarkAsHandled}>
                Bekräfta
              </button>
            </Modal.Footer>
          </Modal>
        </>
      )} */}
      {activeTable === 'review' ? (
  <FollowUpReviewTable
    searchText={searchText}
    orgNumber={reviewFilters.orgNumber}
    name={reviewFilters.name}
    isLoading={loading}
    reviewData={filteredReviewData}
    refetchData={fetchData}
  />
) : activeTable === 'sending' ? (
  <>
    <FollowUpSendingTable
      searchText={searchText}
      orgNumber={sendingFilters.orgNumber}
      name={sendingFilters.name}
      status={sendingFilters.status}
      isHandled={sendingFilters.isHandled}
      isLoading={loading}
      sendingData={filteredSendingData}
      refetchData={fetchData}
      onSelectSending={handleSelectSending}
      selectedSendingIds={selectedSendingIds}
    />
    {selectedSendingIds.length !== 0 && (
      <div className="bulk-actions">
        <button
          className="btn handled-button"
          disabled={selectedSendingIds.length === 0}
          onClick={handleMarkAsHandled}
          style={{ marginTop: '12px' }}
        >
          Markera som slutförd
        </button>
      </div>
    )}

    <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
      <Modal.Header closeButton style={{backgroundColor:'#173c53',color:'white'}}>
        <Modal.Title>Bekräfta Åtgärd</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor:'#fffaf5'}}>
        Är du säker på att du vill markera de valda sändningarna som slutförda?
      </Modal.Body>
      <Modal.Footer style={{backgroundColor:'#fffaf5'}}>
        <button className="btn button-cancel" onClick={() => setShowConfirmModal(false)}>
          Avbryt
        </button>
        <button className="btn" onClick={handleConfirmMarkAsHandled}>
          Bekräfta
        </button>
      </Modal.Footer>
    </Modal>
  </>
) : (
  <FollowUpPhoneReviewTable
    isLoading={loading}
    phoneReviewData={filteredPhoneReviewData}
    refetchData={fetchData}
  />
)}
    </div>
  );
};

export default FollowUpPage;
